import {
  CREATECHANNELPARTNERSETUP,
  GETCHANNELPARTNERSETUP,
  UPDATECHANNELPARTNERSETUP,
  DELETECHANNELPARTNERSETUP,
    GET_CHANNEL_PARTNER_SOURCE,
  CREATE_CHANNEL_PARTNER_SOURCE,
  UPDATE_CHANNEL_PARTNER_SOURCE,
  DELETE_CHANNEL_PARTNER_SOURCE,
  GETCHANNELPARTNERSETUPWITHNULL,
  GETCHANNELPARTNERSETUPWITHOUTNULL,
} from "../actions/types";

const initialState = {};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case CREATECHANNELPARTNERSETUP:
      return {
        ...state,
        channelPartnerSetupSaveStatus: action.payload.success,
      };

    case GETCHANNELPARTNERSETUP:
      return {
        ...state,
        channelPartnerSetupList: action.payload.data,
      };

    case UPDATECHANNELPARTNERSETUP:
      return {
        ...state,
        channelPartnerUpdateStatus: action.payload.success,
      };

    case DELETECHANNELPARTNERSETUP:
      return {
        ...state,
        channelPartnerDeleteStatus: action.payload.success,
        channelPartnerSetupList: state.channelPartnerSetupList.filter(
          (item) => item.id !== action.channelPartnerId,
        ),
      };
        case GET_CHANNEL_PARTNER_SOURCE:
      return {
        ...state,
        sourceTypeList: action.payload.data || [], 
      };

    case CREATE_CHANNEL_PARTNER_SOURCE:
      return {
        ...state,
        sourceSaveStatus: action.payload.success,
      };

    case UPDATE_CHANNEL_PARTNER_SOURCE:
      return {
        ...state,
        sourceUpdateStatus: action.payload.success,
      };

    case DELETE_CHANNEL_PARTNER_SOURCE:
      return {
        ...state,
        sourceDeleteStatus: action.payload.success,
        sourceTypeList: state.sourceTypeList.filter(
          (item) => item.id !== action.sourceId
        ),
      };

    case GETCHANNELPARTNERSETUPWITHNULL:
      return {
        ...state,
        channelPartnerSetupWithNullList: action.payload.data,
      };
    case GETCHANNELPARTNERSETUPWITHOUTNULL:   
      return {
        ...state,
        channelPartnerSetupWithoutNullList: action.payload.data,
      };
    default:
      return state;
  }
}
